import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setTabSelected from "@waytek/Store/Data/Orders/Handlers/SetTabSelected";
import { CustomState } from "@waytek/Store/Reducers";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = ({ customOrderHistoryState: { tabSelected } }: CustomState) => ({ tabSelected });

const mapDispatchToProps = {
    setTabSelected,
};

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasShellContext;

export interface OrderHistoryTabSwitchStyles {
    wrapper?: InjectableCss;
    switchButton?: ButtonPresentationProps;
}

export const tabSwitchStyles: OrderHistoryTabSwitchStyles = {
    wrapper: {
        css: css`
            align-items: center;
            display: flex;
            gap: 10px;
            justify-content: flex-end;
        `,
    },
    switchButton: {
        variant: "primary",
    },
};
const styles = tabSwitchStyles;

const OrderHistoryTabSwitch = ({ tabSelected, setTabSelected, shellContext: { isInShell } }: Props) => {
    const switchOrderHistoryTab = (tabSelected: number) => {
        setTabSelected({ tabSelected });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Button
                {...styles.switchButton}
                onClick={() => switchOrderHistoryTab(0)}
                data-test-selector="orderHistory_switchTab__byOrder"
                disabled={isInShell || tabSelected === 0}
            >
                {translate("View by Order")}
            </Button>

            <Button
                {...styles.switchButton}
                onClick={() => switchOrderHistoryTab(1)}
                data-test-selector="orderHistory_switchTab__byProduct"
                disabled={isInShell || tabSelected === 1}
            >
                {translate("View by Products")}
            </Button>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withIsInShell(OrderHistoryTabSwitch)) as any,
    definition: {
        group: "Order History",
        displayName: "Tab Switch",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
